import React from 'react';

const CTA = () => {
  return (
    <section className="section cta-section">
      <div className="container">
        <div className="cta-content">
          <h2>Ready to transform your customer experience?</h2>
          <p>
            Join 500+ businesses already scaling with AI customer service. 
            Start with a free consultation to see exactly how we'll build your solution.
          </p>
          
          <a 
            href="https://calendly.com/dimitrovovich"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button"
          >
            Book Free Strategy Call
          </a>
          
          <p className="guarantee-text">
            Free consultation • No commitments • 30-day money-back guarantee
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTA;